import viewerStore from "./viewerStore.js";

const initialState = {
  selectableYears: [
    1913,
    1917,
    1921,
    1945,
    // 1949,
    // 1956,
    // 1958,
    // 1960,
    // 1961,
    // 1964,
    // 1966,
    // 1968,
    // 1971,
    // 1974,
    // 1976,
    // 1980,
    // 1984,
    // 1986,
    // 1990,
    // 1995,
    // 1999,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    2016,
    2017,
    2018
  ],
  selectedYearIdx: 0,
  selectedSpriteId: null,
  selectedSpriteData: null,
  selectedGroupings: null,
  searchResults: [],
  languageId: "en",

  domain: {
    images: [],
    audios: [],
    videos: [],
    shapes: [],
    groupings: []
  },

  isShowingPointcloud: true,

  loading: {
    progress: 0,
    flags: {
      isLoadingTiles: false,
      isLoadingShapes: false
    }
  },

  viewerConfig: viewerStore
};

export default initialState;



// WEBPACK FOOTER //
// ./application/frontend/src/store/initial.js